var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDateRange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 11.5H9V13.5H7V11.5ZM21 6.5V20.5C21 21.6 20.1 22.5 19 22.5H5C3.89 22.5 3 21.6 3 20.5L3.01 6.5C3.01 5.4 3.89 4.5 5 4.5H6V2.5H8V4.5H16V2.5H18V4.5H19C20.1 4.5 21 5.4 21 6.5ZM5 8.5H19V6.5H5V8.5ZM19 20.5V10.5H5V20.5H19ZM15 13.5H17V11.5H15V13.5ZM11 13.5H13V11.5H11V13.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateRange);
export default __webpack_public_path__ + "static/media/date_range.5cc8714a432a3bddff545db1693490d4.svg";
export { ForwardRef as ReactComponent };